export default __webpack_public_path__ + "static/media/up_white.bb7ce3e3.svg";